import { authService } from "@/services";

import { axiosWithAuth } from "./axiosInstances";

// Function to get access token from cookies
function getAccessToken(): string | null {
  if (typeof document === "undefined") return null;

  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split("=");
    if (name === "accessToken") {
      return decodeURIComponent(value);
    }
  }
  return null;
}

// Add request interceptor for authentication
axiosWithAuth.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosWithAuth.interceptors.response.use(
  (config) => config,
  async (error) => {
    const originalRequest = error.config;

    if (
      error?.response?.status === 401 &&
      originalRequest &&
      !originalRequest._isRetry &&
      originalRequest.url &&
      !originalRequest.url.includes("logout") &&
      !originalRequest.url.includes("refresh")
    ) {
      originalRequest._isRetry = true;

      try {
        // Refresh tokens using dedicated method
        await authService.getNewTokens();
        return axiosWithAuth.request(originalRequest);
      } catch (refreshError) {
        throw refreshError;
      }
    }
    throw error;
  },
);
